import { createAsyncThunk } from '@reduxjs/toolkit';
import { companyAddressService } from '../../../api';
import { PaginatedRequest } from '../../../types/api';
import { CreateCompanyAddressRequest, UpdateCompanyAddressRequest } from '../../../types/companyAddress';

export const fetchCompanyAddresses = createAsyncThunk(
  'companyAddress/fetch-all',
  ({ companyId, ...params }: { companyId: number } & PaginatedRequest) =>
    companyAddressService.fetchCompanyAddresses(companyId, params),
);

export const createCompanyAddress = createAsyncThunk(
  'companyAddress/create',
  ({ companyId, ...data }: CreateCompanyAddressRequest & { companyId: number }) =>
    companyAddressService.createCompanyAddress(companyId, data),
);

export const updateCompanyAddress = createAsyncThunk(
  'companyAddress/update',
  ({ companyId, id, ...data }: UpdateCompanyAddressRequest & { companyId: number }) =>
    companyAddressService.updateCompanyAddress(companyId, id, data),
);

export const deleteCompanyAddress = createAsyncThunk(
  'companyAddress/delete',
  ({ companyId, id }: { companyId: number; id: number }) => companyAddressService.deleteCompanyAddress(companyId, id),
);
